/**
 * Download a CSV blob from an admin export endpoint.
 */
export async function downloadCsvExport(requestFn, fallbackFilename = 'export.csv') {
  const response = await requestFn();
  const data = response.data;

  if (data instanceof Blob && data.type && data.type.includes('application/json')) {
    const text = await data.text();
    let message = 'Export failed';
    try {
      message = JSON.parse(text)?.message || message;
    } catch {
      /* ignore */
    }
    throw new Error(message);
  }

  const blob = new Blob([data], { type: 'text/csv;charset=utf-8' });

  let filename = fallbackFilename;
  const disposition = response.headers?.['content-disposition'];
  if (disposition) {
    const match = /filename\*?=(?:UTF-8''|")?([^\";]+)/i.exec(disposition);
    if (match?.[1]) {
      filename = decodeURIComponent(match[1].replace(/"/g, '').trim());
    }
  }

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

/** Strip pagination keys before sending filters to export. */
export function exportFiltersFrom(params = {}) {
  const next = { ...params };
  delete next.page;
  delete next.per_page;
  Object.keys(next).forEach((key) => {
    if (next[key] === '' || next[key] === undefined || next[key] === null) {
      delete next[key];
    }
  });
  return next;
}
